import { UseMutationOptions } from '@tanstack/react-query';
import useAppMutation from 'hooks/useAppMutation';
import { BaseErrorResponse } from 'models/_base';
import {
  NewListingDiscountOperation,
  NewListingDiscountOptInOutPayload,
} from 'models/vrbo/NewListingDiscount';
import API from 'services/API';

type OptInOrOutVrboNewListingDiscountArgs =
  NewListingDiscountOptInOutPayload & {
    operation: NewListingDiscountOperation;
  };

type ReactQueryMutationOptions = Omit<
  UseMutationOptions<
    unknown,
    BaseErrorResponse,
    OptInOrOutVrboNewListingDiscountArgs
  >,
  'mutationFn' | 'mutationKey'
>;

const optInOrOutVrboNewListingDiscount = async ({
  agencyUid,
  operation,
  propertyUid,
}: OptInOrOutVrboNewListingDiscountArgs) => {
  return API.post(`/api/internal/vrbo/new-listing-discount/${operation}`, {
    agencyUid,
    propertyUid,
  });
};

const useOptInOrOutVrboNewListingDiscountMutation = ({
  ...options
}: ReactQueryMutationOptions = {}) => {
  return useAppMutation({
    mutationFn: optInOrOutVrboNewListingDiscount,
    ...options,
  });
};

export default useOptInOrOutVrboNewListingDiscountMutation;
